import React, { useState, useEffect } from 'react';
import {
    StyleSheet,
    Text,
    View,
    useWindowDimensions,
    TouchableOpacity,
    ActivityIndicator
} from 'react-native';

import {
   LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, Area, Bar
} from 'recharts';
import { MaterialIcons, FontAwesome } from '@expo/vector-icons';
import DatePicker from "react-datepicker";
import Data from './Data';
import moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";
import {
    setStorage,
    getStorage,
    removeStorage
} from '../storage';

import DropDownPicker from 'react-native-dropdown-picker';

import KalmanFilter from 'kalmanjs';
import Measurement from './measurement/measurement';
import Measurement2 from './measurement/measurement2';

import { CSVLink } from "react-csv";
import { TextInput } from 'react-native-gesture-handler';

const kf = new KalmanFilter();
console.log(kf.filter(3));
console.log(kf.filter(2));
console.log(kf.filter(1));

const CheckBox = ({ checked, color }: any) => {

    return (
        <View>
            {checked ?
                <MaterialIcons name="radio-button-on" size={20} color={color} />
                :
                <MaterialIcons name="radio-button-unchecked" size={20} color={color} />
            }
        </View>
    )
};

const CheckList = ({ item, num, sensorItems, setSensorItems, locationItems, setLocationItems }: any) => {
    const [checked, setChecked] = useState(true);

    const onCheck = (item: any) => {
        setChecked(!checked);
        console.log('checked ?? ', checked);
        if (!checked) {
            if (num == 1) {
                setSensorItems([...sensorItems, item]);
            } else {
                setLocationItems([...locationItems, item]);
            }
        } else {
            if (num == 1) {
                setSensorItems(sensorItems.filter((el: any) => el?.dataKey !== item?.dataKey));
            } else {
                setLocationItems(locationItems.filter((el: any) => el?.dataKey !== item?.dataKey));
            }
        }
    };

    return (
        <TouchableOpacity onPress={() => { onCheck(item) }}
            style={{ flexDirection: 'row', alignItems: 'center', marginHorizontal: 10 }} >
            <CheckBox checked={checked} color={item?.color} />
            <Text style={{ marginLeft: 5, color: item?.color }}>{item?.name}</Text>
        </TouchableOpacity>
    )
};

var intvEabled = false;
// ─── 접근 제한 ──────────────────────────────────────────────
// 원시 데이터 화면(개발·연구용)이라 최고관리자(ADMIN='0')만 연다.
// 버튼을 가려도 주소로 들어올 수 있어 화면에서도 막는다.
// ★ 본문 안에서 조기 return 하면 훅 순서가 깨진다("Rendered fewer hooks than expected").
//   그래서 바깥에서 감싸고, 통과했을 때만 본문 컴포넌트를 띄운다.
export default function SensorAnalysisGate(props: any) {
    const [adm, setAdm] = useState<string | null>(null);
    useEffect(() => { getStorage('AutoLogin').then((v: any) => setAdm(String(v?.admin ?? '1'))); }, []);
    if (adm === null) return null;
    if (adm !== '0') {
        return (
            <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center', padding: 24 }}>
                <Text style={{ fontSize: 16, fontWeight: '700', color: '#475569', marginBottom: 6 }}>접근 권한이 없습니다</Text>
                <Text style={{ fontSize: 13, color: '#94A3B8', textAlign: 'center' }}>이 화면은 최고관리자만 볼 수 있습니다.</Text>
            </View>
        );
    }
    return <SensorAnalysis {...props} />;
}

function SensorAnalysis({ route, navigation }: any) {
    const [csvReport, setCsvReport] = useState<any>({
        data: [],
        headers: [],
        filename: 'csvdata.csv'
    });

    const SizeOfMovingAvg = 30 * 1;
    const SizeOfMovingAvg2 = 30 * 3;
    var measurement1 = new Measurement(route?.params?.sensorID);
    var measurement2 = new Measurement2(route?.params?.sensorID);
    const [autoRefresh, setAutoRefresh] = useState<boolean>(false);
    const [yTrigger, setYtrigger] = useState<boolean>(false);

    const [intCounter, setIntCounter] = useState<number>(0);

    const [sensorID, setSensorID] = useState(route?.params?.sensorID);
    console.log('sensorID ??????? ', sensorID);
    const { height, width } = useWindowDimensions();
    // 폰에서 분석 버튼이 17개나 돼 8줄로 쌓인다. 좁을 때만 작게 줄여 한눈에 들어오게 한다.
    const isNarrowA = width < 900;
    const cmpBtn  = isNarrowA ? { paddingVertical: 3, paddingHorizontal: 9, borderRadius: 11, marginLeft: 0 } : null;
    const cmpFont = isNarrowA ? { fontSize: 12 } : null;
    // 분석 버튼 17개가 그래프를 화면 밖으로 밀어낸다. 폰에서는 기본으로 접어두고 필요할 때 편다.
    const [optOpen, setOptOpen] = useState(false);
    const chartWidth = width * 0.95;
    const chartHeight = height * 0.4;
    const [data, setData] = useState<any>([]);
    const [data1, setData1] = useState<any>([]);
    const [data2, setData2] = useState<any>([]);
    const [data3, setData3] = useState<any>([]);
    const [data4, setData4] = useState<any>([]);
    const [startDate, setStartDate] = useState<any>(new Date());
    const [endDate, setEndDate] = useState<any>(new Date());
    const StartDate = moment(startDate).format('YYYY-MM-DD HH:mm');
    const EndDate = moment(endDate).format('YYYY-MM-DD HH:mm');
    const sensorItem = [
        { dataKey: 'VCC', name: '전압 값', color: '#8884d8' },
        { dataKey: 'CAP', name: '센서 값', color: 'green' },
        { dataKey: 'MOV', name: 'MOV1 값', color: 'red' },
        { dataKey: 'MV5', name: 'MV51 값', color: 'yellow' },
        { dataKey: 'FLT', name: '필터 값', color: 'blue' },
    ];
    const locationItem = [
        { dataKey: 'ACC_X', name: 'x 값', color: '#8884d8' },
        { dataKey: 'ACC_Y', name: 'y 값', color: 'green' },
        { dataKey: 'ACC_Z', name: 'z 값', color: 'orange' }
    ];

    const [sensorItems, setSensorItems] = useState<any>(sensorItem);
    console.log('sensorItems ??', sensorItems);
    const [locationItems, setLocationItems] = useState<any>(locationItem);
    console.log('locationItems ??', locationItems);

    const [sensorValue, setSensorValue] = useState<any>({
        data: [],
        headers: [],
        filename: 'csvdata.csv'
    });
    const [analyze, setAnalyze] = useState<any>({
        data: [],
        headers: [],
        filename: 'csvdata.csv'
    });
    const [records, setRecords] = useState<any>({
        data: [],
        headers: [],
        filename: 'csvdata.csv'
    });

    const [isLoading, setIsLoading] = useState(false);
    const [sensorParam, setSensorParam] = useState<any>({});
    const [sensorInfo, setSensorInfo] = useState<any>(null);

    useEffect(() => {
        const load = async () => {
            const recent = await getStorage(sensorID);
            const Start = recent ? recent.StartDate : StartDate;
            const End = recent ? recent.EndDate : EndDate;
            console.log('Start getValue=', Start);
            console.log('End getValue=', End);
    
            setStorage('RECENTsensorID', sensorID);
    
            if (Start || End) {
                setStartDate(new Date(Start));
                setEndDate(new Date(End));
    
                // GetSensorValues 호출
                Data.fetchData('sensor/GetSensorValues', {
                    SENSOR_ID: sensorID,
                    STARTDATE: moment(new Date(Start)).format('YYYY-MM-DD HH:mm'),
                    ENDDATE: moment(new Date(End)).format('YYYY-MM-DD HH:mm')
                }, (result: any, count: any) => {
                    console.log('GetSensorValues ??', result);
                    if (count > 0) {
                        setListData(result);
                    }
                }, true);

                // GetSensorValuesAndHistory 호출 (날짜 포함)
                Data.fetchData('sensor/GetSensorValuesAndHistory', {
                    SENSOR_ID: sensorID,
                    STARTDATE: moment(new Date(Start)).format('YYYY-MM-DD HH:mm'),
                    ENDDATE: moment(new Date(End)).format('YYYY-MM-DD HH:mm')
                }, (result: any, count: any) => {
                    console.log('GetSensorAllHistory ??', result);
                    setIsLoading(false);
                    if (count > 0) {
                        setListData3(result);
                    }
                }, true);                
            } else {
                // GetSensorValues 호출 (날짜 없이)
                Data.fetchData('sensor/GetSensorValues', {
                    SENSOR_ID: sensorID,
                    STARTDATE: '',
                    ENDDATE: ''
                }, (result: any, count: any) => {
                    console.log('GetSensorValues ??', result);
                    setIsLoading(false);
                    if (count > 0) {
                        setListData(result);
                    }
                }, true);

                // GetSensorValuesAndHistory 호출 (날짜 없이)
                Data.fetchData('sensor/GetSensorValuesAndHistory', {
                    SENSOR_ID: sensorID,
                    STARTDATE: '',
                    ENDDATE: ''
                }, (result: any, count: any) => {
                    console.log('GetSensorValuesAndHistory ??', result);
                    setIsLoading(false);
                    if (count > 0) {
                        setListData3(result);
                    }
                }, true);                
            }
        };
    
        setIsLoading(false);
        load();
    
        const interval = setInterval(() => { intervalTimer() }, 10 * 1000);
    
        return () => clearInterval(interval);
    }, []);

    // 센서 구역/이름 조회 (ID 옆에 표시)
    useEffect(() => {
        if (!sensorID) return;
        Data.fetchData('sensor/getSensorAllListbyUser', {}, (result: any, count: any) => {
            if (count > 0 && Array.isArray(result)) {
                const found = result.find((r: any) => String(r?.SENSOR_ID) === String(sensorID));
                if (found) setSensorInfo(found);
            }
        });
    }, [sensorID]);


    useEffect(() => {
        console.log('autoRefresh!!!', autoRefresh, intCounter);
        if (autoRefresh) {
            onSearch();
            setTimeout(() => {
                setYtrigger((yTrigger) => {
                    return !yTrigger;
                });
            }, 2000)
        }
    }, [intCounter]);

    useEffect(() => {
        console.log('yTrigger!!!', yTrigger, intCounter);
        if (yTrigger) {
            onAccYFilterView();
            setYtrigger(false);
        }
    }, [yTrigger]);


    function intervalTimer() {
        if (intvEabled) {
            setIntCounter((intCounter) => {
                return intCounter + 1;
            });
        }
    }
    
    const timeFommet = (time: any) => {
        if (time) {
            const formattedTime = moment(time).format('HH:mm');
            return formattedTime;
        }
        else return time
    };

    const regdateFommet = (regdate: any) => {
        if (regdate) {
            const formattedDate = moment(regdate).format('HH:mm'); // 원하는 형식으로 변경
            return formattedDate;
        } else {
            return regdate;
        }
    };

    const CustomTooltip = ({ active, payload, label }: any) => {
        if (active && payload) {
            return (
                <View style={styles.tooltip}>
                    <Text style={{ color: '#000', marginBottom: 10 }}>{moment(label).format('YYYY-MM-DD HH:mm:ss')}</Text>
                    {payload?.map((item: any) => {
                        return (<Text key={item?.dataKey} style={{ color: item?.color, marginBottom: 8 }}>{item?.dataKey} : {item?.value}</Text>)
                    })}
                </View >
            )
        }
        return null;
    };

    const CustomStartDatePicker = ({ value, onClick }: any, ref: any) => {
        return (
            <TouchableOpacity onPress={() => { onClick() }} style={styles.datePickerBox}>
                <Text style={{ fontSize: 16, color: '#000' }}>{value}</Text>
            </TouchableOpacity>
        )
    };

    const CustomEndDatePicker = ({ value, onClick }: any, ref: any) => {
        return (
            <TouchableOpacity onPress={() => { onClick() }} style={styles.datePickerBox}>
                <Text style={{ fontSize: 16, color: '#000' }}>{value}</Text>
            </TouchableOpacity>
        )
    };

    const OnStartDatePicker = () => {
        return (
            <DatePicker
                selected={startDate}
                onChange={(date: any) => { setStartDate(date) }}
                timeInputLabel="Time:"
                dateFormat="yyyy-MM-dd HH:mm"
                timeFormat="HH:mm"
                showTimeSelect
                timeIntervals={5}
                customInput={<CustomStartDatePicker />}
            />
        )
    };

    const OnEndDatePicker = () => {
        return (
            <DatePicker
                selected={endDate}
                onChange={(date) => { setEndDate(date) }}
                timeInputLabel="Time:"
                dateFormat="yyyy-MM-dd HH:mm"
                timeFormat="HH:mm"
                showTimeSelect
                timeIntervals={5}
                customInput={<CustomEndDatePicker />}
            />
        )
    };

    const setListData = (result: any) => {
        var list = result.sort(function (a: any, b: any) { return a.ID - b.ID });
        setData(list.reduce((acc: any, cur: any) => {
            acc.push({ ...cur, CAP: cur.CAP1 });
            return acc;
        }, []));
        setData1(list.reduce((acc: any, cur: any) => {
            acc.push({ ...cur, CAP: cur.CAP1 });
            return acc;
        }, []));
        setData2(list.map((el: any) => { return { ...el, CAP: el.CAP2 } }));
    }
    const setListData3 = (result: any) => {
        var list = result.sort((a: any, b: any) => a.ID - b.ID);
    
        setData3(list.map(el => ({
            ...el,
            CAP: el.CAP1,
            소변알림: el.소변알림,
            초기화: el.초기화,
            센서이상: el.센서이상,
            센서오염: el.센서오염,
            기준값: el.기준값,
            자동교체: el.자동교체,
            움직임없음: el.움직임없음
        })));
    
        setData4(list.map(el => ({
            ...el,
            CAP: el.CAP2,
            소변알림: el.소변알림1,
            초기화: el.초기화1,
            센서이상: el.센서이상1,
            센서오염: el.센서오염1,
            기준값: el.기준값1,
            자동교체: el.자동교체1,
            움직임없음: el.움직임없음1
        })));
    };


    const onSearch = () => {
        // setIsLoading(true);
        setStorage(sensorID, { StartDate: startDate, EndDate: endDate });
        Data.fetchData('sensor/GetSensorValues', {
            SENSOR_ID: sensorID,
            STARTDATE: StartDate,
            ENDDATE: EndDate
        }, (result: any, count: any) => {
            console.log('GetSensorValues ?? ', StartDate, EndDate, result);
            setIsLoading(false);

            if (count > 0) {
                setListData(result);
            } else if ((count == -1)) {
                alert('에러가 발생하였습니다.');
            } else {
                alert('해당 날짜의 데이터가 없습니다.');
            }
        }, true);
        const historyHeaders = [
            { label: "IDX", key: "IDX" },
            { label: "SENSOR_ID", key: "ID" },
            { label: "AMOUNT", key: "AMOUNT" },
            { label: "VALUE", key: "VALUE" },
            { label: "KIND", key: "KIND" },
            { label: "BATTERY", key: "BATTERY" },
            { label: "CONNECT", key: "CONNECT" },
            { label: "REPLACEMENT", key: "REPLACEMENT" },
            { label: "POSTURE", key: "POSTURE" },
            { label: "POSTURE_X", key: "POSTURE_X" },
            { label: "POSTURE_Y", key: "POSTURE_Y" },
            { label: "POSTURE_Z", key: "POSTURE_Z" },
            { label: "TIME", key: "TIME" }
        ];
        const recordHeaders = [
            { label: "IDX", key: "IDX" },
            { label: "SENSOR_ID", key: "SENSOR_ID" },
            { label: "ALARM", key: "ALARM" },
            { label: "AMOUNT", key: "AMOUNT" },
            { label: "KIND", key: "KIND" },
            { label: "CLIP", key: "CLIP" },
            { label: "TIME", key: "TIME" }
        ];
        const analyzeHeaders = [
            { label: "SENSOR_ID", key: "SENSOR_ID" },
            { label: "start", key: "start" },
            { label: "end", key: "end" },
            { label: "status", key: "status" },
            { label: "정상", key: "Normal" },
            { label: "에러", key: "Error" },
            { label: "알수없음", key: "Unknown" },
            { label: "정확도", key: "percentage" }
        ];
        var historyFilename = `${sensorID}_Value_` + moment(StartDate).format('YYYYMMDD');
        var recordFilename = `${sensorID}_Record_` + moment(StartDate).format('YYYYMMDD');
        var analyzeFilename = `${sensorID}_Analyze_` + moment(StartDate).format('YYYYMMDD');
        Data.fetchData('sensor/dateTimeFilteredHistory', {
            SENSOR_ID: sensorID,
            STARTDATE: StartDate,
            ENDDATE: EndDate
        }, (result: any, count: any) => {
            // console.log('dateTimeFilteredHistory ??', result);
            if (count > 0) {
                var data = result.map((item: any, index: Number, arr: Array<any>) => {
                    return { ...item, TIME: moment(item.REGDATE).format('YYYY-MM-DD HH:mm:ss') }
                });
                console.log('dateTimeFilteredHistory.data ?? ', StartDate, EndDate, data);
                setSensorValue({
                    data: data,
                    headers: historyHeaders,
                    filename: `${historyFilename}.csv`
                });
            }
        }, true);
        Data.fetchData('sensor/dateTimeFilteredHistory2', {
            SENSOR_ID: sensorID,
            STARTDATE: StartDate,
            ENDDATE: EndDate
        }, (result: any, count: any) => {
            console.log('dateTimeFilteredHistory2 ??', result);
        
            // count가 0보다 큰 경우에만 처리
            if (count > 0) {
                var data = result.map((item: any) => {
                    // start와 end 날짜를 포맷팅하여 새로운 배열을 생성
                    return {
                        ...item,
                        start: moment(item.start).format('YYYY:MM:DD HH:mm'),
                        end: moment(item.end).format('YYYY:MM:DD HH:mm'),
                    };
                });
        
                // 분석 결과를 상태로 설정
                setAnalyze({
                    data: data,  // 포맷팅된 데이터를 사용
                    headers: analyzeHeaders,
                    filename: `${analyzeFilename}.csv`
                });
            }
        }, true);
        Data.fetchData('sensor/dateTimeFilteredClinicalRecords', {
            SENSOR_ID: sensorID,
            STARTDATE: StartDate,
            ENDDATE: EndDate
        }, (result: any, count: any) => {
            console.log('dateTimeFilteredClinicalRecords ??', result);
            if (count > 0) {
                var data = result.map((item: any, index: Number, arr: Array<any>) => {
                    return { ...item, TIME: moment(item.REGDATE).format('YYYY-MM-DD HH:mm:ss') }
                });
                console.log('dateTimeFilteredClinicalRecords.data ?? ', data);
                setRecords({
                    data: data,
                    headers: recordHeaders,
                    filename: `${recordFilename}.csv`
                });
            }
        }, true);

        Data.fetchData('gwsensor/getSensorParam', {
            SENSOR_ID: sensorID
        }, (result: any, count: any) => {
            console.log('getSensorParam ??', result,);
            if (count > 0) {
                setSensorParam(result[0]);
            }
        }, true);
        
        Data.fetchData('sensor/GetSensorValuesAndHistory', {
            SENSOR_ID: sensorID,
            STARTDATE: StartDate,
            ENDDATE: EndDate
        }, (result: any, count: any) => {
            console.log('GetSensorValuesAndHistory ??', StartDate, EndDate, result);
            setIsLoading(false);
            if (count > 0) {
                setListData3(result);
            }
        }, true);
    };

    const onRecentView = () => {
        setIsLoading(true);
        setStartDate(new Date());
        setEndDate(new Date());
        Data.fetchData('sensor/GetSensorValues', {
            SENSOR_ID: sensorID,
            STARTDATE: '',
            ENDDATE: ''
        }, (result: any, count: any) => {
            console.log('GetSensorValues ??', result);
            setIsLoading(false);
            if (count > 0) {
                setListData(result);
            }
        }, true);
        Data.fetchData('gwsensor/getSensorParam', {
            SENSOR_ID: sensorID
        }, (result: any, count: any) => {
            console.log('getSensorParam ??', result,);
            if (count > 0) {
                setSensorParam(result[0]);
            }
        }, true);
        Data.fetchData('sensor/GetSensorValuesAndHistory', {
            SENSOR_ID: sensorID,
            STARTDATE: '',
            ENDDATE: ''
        }, (result: any, count: any) => {
            console.log('GetSensorValuesAndHistory ??', result);
            setIsLoading(false);
            if (count > 0) {
                setListData3(result);
            }
        }, true);
    };

    function calcAbsDeviation(vals: Int32Array) {
        const sum = vals.reduce((t, c) => t + c, 0);
        const mean = sum / vals.length;
        const devtot = vals.reduce((t, c) => t + Math.abs(c - mean), 0);
        const stddev = devtot / vals.length;
        return { sum: sum, mean: parseInt(mean.toFixed(0)), devtot: parseInt(devtot.toFixed(0)), stddev: parseInt(stddev.toFixed(0)) };
    }


    function calcMoving(list: any, min: any, name: string) {
        console.log('list=', list);
        var len = list.length;
        var sum = 0;
        var min = list.length < min ? len : min;
        for (var i = 0; i < len; ++i) {
            list[i].devtot = 0;
            list[i].stddev = 0;
        }
        for (var i = 0; i < min - 1; i++) {
            sum = sum + list[i][name];	//m-1까지의 부분sum
        }
        for (var i = 0; i < min - 1; i++) {
            list[i].moving = (sum / (min - 1));
            list[i].devtot = (list[i].devtot ? list[i].devtot : 0) + Math.abs(list[i][name] - list[i].moving);
            list[i].stddev = (list[i].devtot / (min - 1));
        }

        for (var i = min - 1; i < list.length; i++) {
            sum = sum + list[i][name];
            list[i].moving = (sum / min);
            list[i].devtot = (list[i].devtot ? list[i].devtot : 0) + Math.abs(list[i][name] - list[i].moving);
            list[i].stddev = (list[i].devtot / min);
            sum = sum - list[i - min + 1][name];
        }
        console.log('result=', list);
    }

    function calcSlopeMov(name: string, prev: any, curr: any) {
        var d1 = (curr[name + '_MOV'] - prev[name + '_MOV']);
        var t1 = ((new Date(curr.TIME)).getTime() - (new Date(prev.TIME)).getTime());
        if (t1 > 0) {
            return d1 / t1;
        }
        return 0;
    }

    function calcSlopeKalman(name: string, prev: any, curr: any) {
        var d1 = (curr[name + '_FLT'] - prev[name + '_FLT']);
        var t1 = ((new Date(curr.TIME)).getTime() - (new Date(prev.TIME)).getTime());
        if (t1 > 0) {
            return d1 / t1;
        }
        return 0;
    }


    function recMovingByName(list: any, name: string, minx: number, movmilisecs: number = 0, begval: number = 0, endval: number = 0) {
        const SLOPE_BEG = 0.0005;
        const SLOPE_END = 0.0002;
        const SLOPE_MAX = 0.008;
        const DELTA_MAX = 4 * 60 * 1000;
        const result = calcAbsDeviation(list.map((el: any) => parseInt(el[name])));
        console.log('caps =', result);

        var len = list.length;
        var beg = 0, beg2 = 0, end = 0, end2 = 0, mid = 0, mid2 = 0;
        var prvbeg = 0, prvend = 0;
        var nextAdd = 0;
        // check cross point
        for (var i = 0; i < len; i++) {
            var x = (list[i][name + '_MOV'] - list[i][name + '_MV5']);
            if (i > 0) {
                beg = end = prvend;
                beg2 = 0;
                end2 = 0;

                var slbeg = calcSlopeKalman(name, list[i - 1], list[i]);
                // console.log('rec slope:', slbeg, list[i]);
                if (Math.abs(slbeg) > SLOPE_MAX) {
                    console.log('rec max slope:', slbeg, list[i]);
                    var x2 = (list[i][name + '_MOV'] - list[i][name + '_MV5']);
                    for (var j = i; j > prvend; --j) {
                        var x1 = (list[j][name + '_MOV'] - list[j][name + '_MV5']);
                        if (j > 0) {
                            var sl = calcSlopeKalman(name, list[j - 1], list[j]);
                            if (Math.abs(sl) > 0 && Math.abs(sl) < SLOPE_BEG && beg2 == 0) {
                                console.log('rec beg2 slope:', sl, list[j]);
                                beg2 = j;
                            }
                        }
                        if ((x2 > 0 && x1 <= 0) || (x2 < 0 && x1 >= 0)) {
                            beg = prvbeg < j ? j : beg;
                            break;
                        }
                    }
                    beg = beg2 > beg ? beg2 : beg;
                    beg = beg > 1 ? --beg : 0;
                    console.log('rec beg:', i, beg, beg2, list[beg]);
                    end = len - 1;
                    for (var j = i; j < len; ++j) {
                        if (j > 1) {
                            var sl = calcSlopeKalman(name, list[j - 1], list[j]);
                            // console.log('rec end slope:', sl, list[j]);
                            if ((slbeg < 0 && sl > 0 && sl > SLOPE_END) || (slbeg > 0 && sl < 0 && sl < (-SLOPE_END))
                                || (Math.abs(sl) > 0 && Math.abs(sl) < SLOPE_END)) {
                                console.log('rec fend slope:', sl, list[j]);
                                end = j;
                                var tdelta = ((new Date(list[j].TIME)).getTime() - (new Date(list[beg].TIME)).getTime());
                                if (tdelta < (30 * 1000)) {
                                    slbeg = sl;
                                } else {
                                    break;
                                }
                            }
                        }
                    }
                    // end = end < (len - 1) ? end+1 : end;
                    var prvadd = nextAdd;
                    nextAdd = (list[beg]['CAP_FLT'] - list[end]['CAP_MOV']);
                    console.log('rec adj beg:', beg, 'i:', i, 'end:', mid, nextAdd, list[end]);
                    for (var j = beg; j < len; j++) {
                        if (true) {
                            if (j < end) {
                                // list[j]['CAP_ADJ'] = list[beg]['CAP_MOV'] + prvadd;
                                var start = 0;// list[beg]['CAP_MOV'] - list[beg]['CAP_ADJ'];
                                var start2 = list[beg]['CAP_ADJ'] - start;
                                var rangeAdd = (start2 - list[j]['CAP_ADJ']);
                                // list[j]['CAP_ADJ'] = list[j]['CAP_ADJ'] + rangeAdd;
                                list[j]['CAP_ADJ'] = list[j]['CAP_ADJ'] + nextAdd;
                            } else {
                                list[j]['CAP_ADJ'] = list[j]['CAP_ADJ'] + nextAdd;
                            }
                        } else {
                            list[j]['CAP_ADJ'] = list[j]['CAP_ADJ'] + nextAdd;
                            // console.log('CAP_ADJ beg:', beg, 'end:', j, end, nextAdd, list[j]['CAP_ADJ']);
                        }
                    }
                    // if (begval != 0) {
                    //     list[beg][name + '_ADJ'] = begval;
                    //     list[end][name + '_ADJ'] = begval;
                    // }
                    // if (endval != 0) {
                    //     list[end][name + '_ADJ'] = endval;
                    // }
                    if (endval == 0) {
                        for (var j = beg; j < end; j++) {
                            // list[j][name + '_ADJ'] = begval;
                        }
                    }
                    i = end + 1;
                    prvend = i;
                    prvbeg = beg;
                }

            }
            if (false && Math.abs(x) > minx) {
                beg = end = prvend;
                beg2 = 0;
                end2 = 0;
                mid2 = 0;
                console.log('rec mx:', list[i]);
                var x2 = (list[i][name + '_MOV'] - list[i][name + '_MV5']);
                for (var j = i; j > prvend; --j) {
                    var x1 = (list[j][name + '_MOV'] - list[j][name + '_MV5']);
                    if (j > 0) {
                        var d1 = (list[j - 1][name + '_MV5'] - list[j][name + '_MV5']);
                        var t1 = ((new Date(list[i].TIME)).getTime() - (new Date(list[j].TIME)).getTime());
                        var sl = d1 / t1;
                        if (Math.abs(sl) > 0 && Math.abs(sl) < SLOPE_BEG && beg2 == 0) {
                            console.log('b slope:', sl, list[j]);
                            beg2 = j;
                        }
                    }
                    if ((x2 > 0 && x1 <= 0) || (x2 < 0 && x1 >= 0)) {
                        beg = prvbeg < j ? j : beg;
                        break;
                    }
                }
                beg = beg > 1 ? --beg : 0;
                beg = beg2 > beg ? beg2 : beg;
                console.log('rec beg:', i, beg, list[beg]);
                end = len - 1;
                mid = j;
                for (var j = i; j < len; ++j) {
                    var x1 = (list[j][name + '_MOV'] - list[j][name + '_MV5']);
                    if (j > 0) {
                        var d1 = (list[j - 1][name + '_MV5'] - list[j][name + '_MV5']);
                        var t1 = ((new Date(list[i].TIME)).getTime() - (new Date(list[j].TIME)).getTime());
                        var sl = d1 / t1;
                        if (Math.abs(sl) > 0 && Math.abs(sl) < SLOPE_BEG && end2 == 0) {
                            console.log('rec e slope:', sl, list[j]);
                            end = end2 = j;
                            break;
                        }
                    }
                    if (Math.abs(x1) >= Math.abs(x)) {
                        mid = j;
                        x = x1;
                    }
                    if ((x2 > 0 && x1 <= 0) || (x2 < 0 && x1 >= 0)) {
                        end = j;
                        if (movmilisecs > 0) {
                            var endtime = (new Date(list[end].TIME)).getTime() + movmilisecs;
                            while (j < len && (new Date(list[j].TIME)).getTime() < endtime) {
                                end = j;
                                ++j;
                            }
                        }
                        break;
                    }
                }
                console.log('rec m slop:', beg, mid, end, list[mid]);

                if (true) {
                    var prvadd = nextAdd;
                    nextAdd = (list[beg]['CAP_MOV'] - list[end]['CAP_MOV']);
                    var deltatime = (new Date(list[mid].TIME)).getTime() - (new Date(list[beg].TIME)).getTime();
                    // if (deltatime >= DELTA_MAX && beg2 > 0) {
                    //     console.log('rec change from deltatime:', beg, beg2);
                    //     beg = beg2;
                    //     deltatime = (new Date(list[mid].TIME)).getTime() - (new Date(list[beg].TIME)).getTime();
                    // }

                    console.log('rec adj beg:', beg, 'i:', i, 'mid:', mid, nextAdd, 'deltatime:', deltatime, list[mid]);
                    if (deltatime < DELTA_MAX || x < 0) {
                        for (var j = beg; j < len; j++) {
                            if (true) {
                                if (j < mid) {
                                    // list[j]['CAP_ADJ'] = list[beg]['CAP_MOV'] + prvadd;
                                    var start = 0;// list[beg]['CAP_MOV'] - list[beg]['CAP_ADJ'];
                                    var start2 = list[beg]['CAP_ADJ'] - start;
                                    var rangeAdd = (start2 - list[j]['CAP_ADJ']);
                                    // list[j]['CAP_ADJ'] = list[j]['CAP_ADJ'] + rangeAdd;
                                    list[j]['CAP_ADJ'] = list[j]['CAP_ADJ'] + nextAdd;
                                } else {
                                    list[j]['CAP_ADJ'] = list[j]['CAP_ADJ'] + nextAdd;
                                }
                            } else {
                                list[j]['CAP_ADJ'] = list[j]['CAP_ADJ'] + nextAdd;
                                // console.log('CAP_ADJ beg:', beg, 'end:', j, end, nextAdd, list[j]['CAP_ADJ']);
                            }
                        }
                    }
                }

                // if (j == len) {
                //     list[j - 1][name + '_ADJ'] = list[j - 1][name + '_ADJ'] - nextAdd;
                // }
                if (begval != 0) {
                    list[beg][name + '_ADJ'] = begval;
                    list[mid][name + '_ADJ'] = begval;
                }
                if (endval != 0) {
                    list[mid][name + '_ADJ'] = endval;
                }
                if (endval == 0) {
                    for (var j = beg; j < mid; j++) {
                        // list[j][name + '_ADJ'] = begval;
                    }
                }
                i = end + 1;
                prvend = i;
                prvbeg = beg;
                // break;
            }
        }

        console.log('result=', list);
        return list;
    }

    function cutMovingByAcc(list: any, name: string, minx: number, movmilisecs: number = 0, begval: number = 0, endval: number = 0) {
        const SLOPE_BEG = 0.01;
        const SLOPE_END = 0.01;
        const SLOPE_MAX = 0.008;

        const result = calcAbsDeviation(list.map((el: any) => parseInt(el[name])));
        console.log('caps =', result);

        var len = list.length;
        var beg = 0, beg2 = 0, end = 0, end2 = 0, mid = 0, mid2 = 0;
        var prvbeg = 0, prvend = 0;
        var nextAdd = 0;
        // check cross point
        // for (var i = 0; i < len; i++) {
        //     list[i][name + '_ADJ'] = list[i][name];
        // }
        for (var i = 0; i < len; i++) {
            var x = Math.abs(list[i][name + '_MOV'] - list[i][name + '_MV5']);
            if (i > 0) {
                beg = end = prvend;
                beg2 = 0;
                end2 = 0;

                var slbeg = calcSlopeKalman(name, list[i - 1], list[i]);
                if (Math.abs(slbeg) > SLOPE_MAX) {
                    console.log('rec max slope:', slbeg, list[i].TIME);
                    var x2 = (list[i][name + '_MOV'] - list[i][name + '_MV5']);
                    for (var j = i; j > prvend; --j) {
                        var x1 = (list[j][name + '_MOV'] - list[j][name + '_MV5']);
                        if (j > 0) {
                            var sl = calcSlopeKalman(name, list[j - 1], list[j]);
                            if (Math.abs(sl) > 0 && Math.abs(sl) < SLOPE_BEG && beg2 == 0) {
                                console.log('rec beg2 slope:', sl, list[j].TIME);
                                beg2 = j;
                            }
                        }
                        if ((x2 > 0 && x1 <= 0) || (x2 < 0 && x1 >= 0)) {
                            beg = prvbeg < j ? j : beg;
                            break;
                        }
                    }

                    beg = beg2 > beg ? beg2 : beg;
                    beg = beg > 1 ? --beg : 0;
                    console.log('rec beg:', i, beg, beg2, list[beg]);
                    end = len - 1;
                    for (var j = i; j < len; ++j) {
                        if (j > 1) {
                            var sl = calcSlopeKalman(name, list[j - 1], list[j]);
                            // console.log('rec end slope:', sl, list[j]);
                            if ((slbeg < 0 && sl > 0 && sl > SLOPE_END) || (slbeg > 0 && sl < 0 && sl < (-SLOPE_END))
                                // || (Math.abs(sl) > 0 && Math.abs(sl) < SLOPE_END)
                            ) {
                                console.log('rec fend slope:', sl, list[j]);
                                end = j;
                                break;
                            }
                        }
                    }

                    var prvadd = nextAdd;
                    nextAdd = (list[beg]['CAP_MV5'] - list[end]['CAP_MOV']);
                    // var nextarr2 = list.slice(beg + ((end-beg)/2),end);
                    // var result2 = calcAbsDeviation(nextarr2.map((el: any) => parseFloat(el['CAP_MOV'])));
                    // nextAdd  = (list[beg]['CAP_MOV'] - result2.mean);
                    console.log('rec adj beg:', beg, 'i:', i, 'end:', end, nextAdd, list[end].TIME);
                    for (var j = beg; j < len; j++) {
                        if (true) {
                            if (j < end) {
                                // list[j]['CAP_ADJ'] = list[beg]['CAP_MOV'] + prvadd;
                                var start = 0;// list[beg]['CAP_MOV'] - list[beg]['CAP_ADJ'];
                                var start2 = list[beg]['CAP_ADJ'] - start;
                                var rangeAdd = (start2 - list[j]['CAP_ADJ']);
                                // list[j]['CAP_ADJ'] = list[j]['CAP_ADJ'] + rangeAdd;
                                list[j]['CAP_ADJ'] = list[j]['CAP_ADJ'] + nextAdd;
                            } else {
                                list[j]['CAP_ADJ'] = list[j]['CAP_ADJ'] + nextAdd;
                            }
                        } else {
                            list[j]['CAP_ADJ'] = list[j]['CAP_ADJ'] + nextAdd;
                            // console.log('CAP_ADJ beg:', beg, 'end:', j, end, nextAdd, list[j]['CAP_ADJ']);
                        }
                    }
                    if (begval != 0) {
                        list[beg][name + '_ADJ'] = begval;
                        list[end][name + '_ADJ'] = begval;
                    }
                    if (endval != 0) {
                        list[end][name + '_ADJ'] = endval;
                    }
                    if (endval == 0) {
                        for (var j = beg; j < end; j++) {
                            // list[j][name + '_ADJ'] = begval;
                        }
                    }
                    i = end + 1;
                    prvend = i;
                    prvbeg = beg;
                }

            }
            if (false && x > minx) {
                beg = end = i;
                var x2 = (list[i][name + '_MOV'] - list[i][name + '_MV5']);
                for (var j = i; j > 0; --j) {
                    var x1 = (list[j][name + '_MOV'] - list[j][name + '_MV5']);
                    if ((x2 > 0 && Math.abs(x1) <= 5) || (x2 < 0 && Math.abs(x1) >= 5)) {
                        beg = j;
                        var cutduration = 10 * 1000;
                        var begtime = (new Date(list[beg].TIME)).getTime() - cutduration;
                        while (j > 0 && (new Date(list[j].TIME)).getTime() > begtime) {
                            beg = j;
                            --j;
                        }
                        break;
                    }
                }

                beg = beg > 1 ? (beg - 1) : 0;
                console.log('beg:', i, beg, list[beg]);

                mid = j;
                for (var j = i; j < len; ++j) {
                    var x1 = (list[j][name + '_MOV'] - list[j][name + '_MV5']);
                    if (Math.abs(x1) >= x) {
                        mid = j;
                        x = Math.abs(x1);
                    }
                    if ((x2 > 0 && x1 <= 0) || (x2 < 0 && x1 >= 0)) {
                        end = j;
                        if (movmilisecs > 0) {
                            var endtime = (new Date(list[end].TIME)).getTime() + movmilisecs;
                            while (j < len && (new Date(list[j].TIME)).getTime() < endtime) {
                                end = j;
                                ++j;
                            }
                        }
                        break;
                    }
                }

                console.log('end:', i, end, list[end]);
                if (true) {
                    console.log('adj beg:', beg, 'end:', i, end, list[end]);
                    var prvadd = nextAdd;
                    nextAdd = (list[beg]['CAP_MOV'] - list[end]['CAP_MOV']);//- nextAdd;
                    for (var j = beg; j < len; j++) {
                        // if (j < mid) {
                        //     list[j]['CAP_ADJ'] = list[beg]['CAP_MOV'] + prvadd; // list[j]['CAP_ADJ'] + nextAdd;
                        // } else {
                        //     list[j]['CAP_ADJ'] = list[j]['CAP_ADJ'] + nextAdd;
                        // }
                        list[j]['CAP_ADJ'] = list[j]['CAP_ADJ'] + nextAdd;
                    }
                }
                if (begval != 0) {
                    list[beg][name + '_ADJ'] = begval;
                    list[mid][name + '_ADJ'] = begval;
                }
                if (endval != 0) {
                    list[mid][name + '_ADJ'] = endval;
                }
                if (endval == 0) {
                    for (var j = beg; j < mid; j++) {
                        // list[j][name + '_ADJ'] = begval;
                    }
                }
                i = end + 1;
                beg = end = 0;
                // break;
            }
        }

        console.log('result=', list);
        return list;
    }

    function cutMovingByName(list: any, name: string, minx: number, movmilisecs: number = 0, begval: number = 0, endval: number = 0) {
        const result = calcAbsDeviation(list.map((el: any) => parseInt(el[name])));
        console.log('caps =', result);

        var len = list.length;
        var beg = 0, end = 0, mid = 0;
        var nextAdd = 0;
        // check cross point
        for (var i = 0; i < len; i++) {
            var x = Math.abs(list[i][name + '_MOV'] - list[i][name + '_MV5']);
            if (x > minx) {
                beg = end = i;
                var x2 = (list[i][name + '_MOV'] - list[i][name + '_MV5']);
                for (var j = i; j > 0; --j) {
                    var x1 = (list[j][name + '_MOV'] - list[j][name + '_MV5']);
                    if ((x2 > 0 && x1 <= 5) || (x2 < 0 && x1 >= 5)) {
                        beg = j;
                        break;
                    }
                }
                beg = beg > 1 ? --beg : 0;
                console.log('beg:', i, beg, list[beg]);
                end = len - 1;
                mid = j;
                for (var j = i; j < len; ++j) {
                    var x1 = (list[j][name + '_MOV'] - list[j][name + '_MV5']);
                    if (Math.abs(x1) >= x) {
                        mid = j;
                        x = Math.abs(x1);
                    }
                    if ((x2 > 0 && x1 <= 0) || (x2 < 0 && x1 >= 0)) {
                        end = j;
                        if (movmilisecs > 0) {
                            var endtime = (new Date(list[end].TIME)).getTime() + movmilisecs;
                            while (j < len && (new Date(list[j].TIME)).getTime() < endtime) {
                                end = j;
                                ++j;
                            }
                        }
                        break;
                    }
                }

                if (true) {
                    console.log('adj beg:', beg, 'end:', i, end, list[end]);
                    var prvadd = nextAdd;
                    nextAdd = (list[beg]['CAP_MOV'] - list[end]['CAP_MOV']);
                    for (var j = beg; j < len; j++) {
                        if (false) {
                            if (j < end) {
                                // list[j]['CAP_ADJ'] = list[beg]['CAP_MOV'] + prvadd;
                                var start = list[beg]['CAP_ADJ'];
                                var rangeAdd = (start - list[j]['CAP_ADJ']);
                                list[j]['CAP_ADJ'] = list[j]['CAP_ADJ'] + rangeAdd;
                                // list[j]['CAP_ADJ'] = list[j]['CAP_ADJ'] + nextAdd;
                            } else {
                                list[j]['CAP_ADJ'] = list[j]['CAP_ADJ'] + nextAdd;
                            }
                        } else {
                            list[j]['CAP_ADJ'] = list[j]['CAP_ADJ'] + nextAdd;
                        }
                    }
                }

                // if (j == len) {
                //     list[j - 1][name + '_ADJ'] = list[j - 1][name + '_ADJ'] - nextAdd;
                // }
                if (begval != 0) {
                    list[beg][name + '_ADJ'] = begval;
                    list[mid][name + '_ADJ'] = begval;
                }
                if (endval != 0) {
                    list[mid][name + '_ADJ'] = endval;
                }
                if (endval == 0) {
                    for (var j = beg; j < mid; j++) {
                        list[j][name + '_ADJ'] = begval;
                    }
                }
                i = end + 1;
                beg = end = 0;
                // break;
            }
        }

        console.log('result=', list);
        return list;
    }

    function cutMovingBySTD(list: any, name: string, minx: number, movmilisecs: number = 0, begval: number = 0, endval: number = 0) {
        const result = calcAbsDeviation(list.map((el: any) => parseInt(el[name])));
        console.log('caps =', result);

        var len = list.length;
        var beg = 0, end = 0, mid = 0;
        var nextAdd = 0;
        // check cross point
        // for (var i = 0; i < len; i++) {
        //     list[i][name + '_ADJ'] = list[i][name];
        // }
        for (var i = 0; i < len; i++) {
            var x = (list[i][name + '_FLT'] - list[i][name + '_FL5']);
            if (x > minx) {
                beg = end = i;
                var x2 = (list[i][name + '_FLT'] - list[i][name + '_FL5']);
                for (var j = i; j > 0; --j) {
                    var x1 = (list[j][name + '_FLT'] - list[j][name + '_FL5']);
                    if ((x2 > 0 && x1 <= 0) || (x2 < 0 && x1 >= 0)) {
                        beg = j;
                        // var cutduration = 10 * 1000;
                        // var begtime = (new Date(list[beg].TIME)).getTime() - cutduration;
                        // while (j > 0 && (new Date(list[j].TIME)).getTime() > begtime) {
                        //     beg = j;
                        //     --j;
                        // }
                        break;
                    }
                }

                beg = beg > 1 ? (beg - 1) : 0;
                console.log('beg:', i, beg, list[beg]);

                mid = j;
                for (var j = i; j < len; ++j) {
                    var x1 = (list[j][name + '_FLT'] - list[j][name + '_FL5']);
                    if (x1 < x2) {
                        mid = j;
                        x2 = x1;
                    }
                    if (x2 < 0 && x1 >= 0) {
                        end = j;
                        if (movmilisecs > 0) {
                            var endtime = (new Date(list[end].TIME)).getTime() + movmilisecs;
                            while (j < len && (new Date(list[j].TIME)).getTime() < endtime) {
                                end = j;
                                ++j;
                            }
                        }
                        break;
                    }
                }

                console.log('end:', i, end, list[end]);
                if (true) {
                    console.log('adj beg:', beg, 'end:', i, end, list[end]);
                    var prvadd = nextAdd;
                    nextAdd = (list[beg]['CAP_MOV'] - list[end]['CAP_MOV']);//- nextAdd;
                    for (var j = beg; j < len; j++) {
                        // if (j < end) {
                        //     list[j]['CAP_ADJ'] = list[beg]['CAP_MOV'] + prvadd; // list[j]['CAP_ADJ'] + nextAdd;
                        // } else {
                        list[j]['CAP_ADJ'] = list[j]['CAP_ADJ'] + nextAdd;
                        // }
                    }
                }
                if (begval != 0) {
                    list[beg][name + '_ADJ'] = begval;
                    list[end][name + '_ADJ'] = begval;
                }
                if (endval != 0) {
                    list[end][name + '_ADJ'] = endval;
                }
                if (endval == 0) {
                    for (var j = beg; j < end; j++) {
                        list[j][name + '_ADJ'] = begval;
                    }
                }
                i = end + 1;
                beg = end = 0;
                // break;
            }
        }

        console.log('result=', list);
        return list;
    }


    function cutAdjustByAcc(list: any, name: string, minx: number, movmilisecs: number = 0, begval: number = 0, endval: number = 0) {
        const result = calcAbsDeviation(list.map((el: any) => parseInt(el[name])));
        console.log('caps =', result);

        var len = list.length;
        var beg = 0, end = 0;
        var nextAdd = 0;
        // check cross point
        // for (var i = 0; i < len; i++) {
        //     list[i][name + '_ADJ'] = list[i][name];
        // }
        for (var i = 0; i < len; i++) {
            var x = Math.abs(list[i][name + '_MOV'] - list[i][name + '_MV5']);
            if (x > minx) {
                beg = end = i;
                var x2 = (list[i][name + '_MOV'] - list[i][name + '_MV5']);
                for (var j = i; j > 0; --j) {
                    var x1 = (list[j][name + '_MOV'] - list[j][name + '_MV5']);
                    if ((x2 > 0 && x1 <= 0) || (x2 < 0 && x1 >= 0)) {
                        beg = j;
                        break;
                    }
                }

                beg = beg > 1 ? --beg : 0;
                console.log('beg:', i, beg, list[beg]);

                for (var j = i; j < len; ++j) {
                    var x1 = (list[j][name + '_MOV'] - list[j][name + '_MV5']);
                    if ((x2 > 0 && x1 <= 0) || (x2 < 0 && x1 >= 0)) {
                        end = j;
                        if (movmilisecs > 0) {
                            var endtime = (new Date(list[end].TIME)).getTime() + movmilisecs;
                            while (j < len && (new Date(list[j].TIME)).getTime() < endtime) {
                                end = j;
                                ++j;
                            }
                        }
                        break;
                    }
                }
                console.log('end:', i, end, list[i]);
                if (true) {
                    console.log('adj beg:', beg, 'end:', i, end, list[i]);
                    nextAdd = list[beg]['CAP_MOV'] - list[end]['CAP_MOV'];
                    for (var j = beg; j < len; j++) {
                        list[j]['CAP_ADJ'] = list[j]['CAP_ADJ'] + nextAdd;
                    }
                }
                if (begval != 0) {
                    list[beg][name + '_ADJ'] = begval;
                    list[end][name + '_ADJ'] = begval;
                }
                if (endval != 0) {
                    list[end][name + '_ADJ'] = endval;
                }
                if (endval == 0) {
                    for (var j = beg; j < end; j++) {
                        list[j][name + '_ADJ'] = begval;
                    }
                }
                i = end + 1;
                beg = end = 0;
                // break;
            }
        }

        console.log('result=', list);
        return list;
    }

    function rmFilter(list: any, cutvals: any = []) {
        console.log('list=', list);
        cutvals.map((item: any, index: Number, arr: Array<any>) => {
            list = list.filter((el: any) => (el[item.name + '_ADJ'] != item.beg));
        });
        console.log('result=', list);
        return list;
    }

    const applyFilter = (list: any, name: string) => {
        // var kalmanFilter = new KalmanFilter({ R: 0.1, Q: 1 });
        // var kalmanFilter = new KalmanFilter({ R: 0.005, Q: 30 });
        var kalmanFilter = new KalmanFilter({ R: 0.02, Q: 5 });
        var kalmanFilter5 = new KalmanFilter({ R: 0.01, Q: 1 });
        //var kalmanFilter = new KalmanFilter({ R: 0.01, Q: 20, A: 1.1 });
        console.log('name =', name, list);

        for (var i = 0; i < list.length; i++) {
            list[i][name + '_ADJ'] = list[i][name];
        }

        const result = calcAbsDeviation(list.map((el: any) => parseInt(el[name])));
        console.log('caps =', result);

        calcMoving(list, SizeOfMovingAvg, name);
        var list = list.map((item: any, index: Number, arr: Array<any>) => {
            return { ...item, [name + '_MOV']: item.moving ? item.moving : item[name] }
        });

        var list = list.map((item: any, index: Number, arr: Array<any>) => {
            return { ...item, [name + '_STD']: result.mean + (item.stddev ? item.stddev * 10 : 0) }
        });

        calcMoving(list, SizeOfMovingAvg2, name);
        var list = list.map((item: any, index: Number, arr: Array<any>) => {
            return { ...item, [name + '_MV5']: item.moving ? item.moving : item[name] }
        });

        var list = list.map((item: any, index: Number, arr: Array<any>) => {
            return { ...item, [name + '_FLT']: kalmanFilter.filter(item[name]) }
        });

        var list = list.map((item: any, index: Number, arr: Array<any>) => {
            return { ...item, [name + '_FL5']: kalmanFilter5.filter(item[name + '_STD']) }
        });

        return list;
    }

    const ACC_DEPTH = 30;
    const ACC_DELAY_TIME = 1 * 60 * 1000;

    const onCap2View = () => {
        var listadj = data2.map((item: any, index: Number, arr: Array<any>) => {
            return { ...item, CAP: item.CAP }
        });
        setData(listadj);
        setData1(listadj);
    };

    const onApllyDataView = () => {
        var listadj = data.map((item: any, index: Number, arr: Array<any>) => {
            return { ...item, CAP: item.CAP_ADJ }
        });
        setData(listadj);
        setData1(listadj);
    };

    const onAccYFilterView = () => {
        console.log('onAccYFilterView started');  // 함수 시작 로그
        var listadj = applyFilter(data, "CAP");
        var listadj = cutMovingByAcc(applyFilter(listadj, "ACC_Y"), "ACC_Y", ACC_DEPTH, ACC_DELAY_TIME, -1800);
        setData(listadj);
        setData1(listadj);
    };

    const onAccXFilterView = () => {
        var listadj = applyFilter(data, "CAP");
        var listadj = cutMovingByAcc(applyFilter(listadj, "ACC_X"), "ACC_X", ACC_DEPTH, ACC_DELAY_TIME, -1800);
        setData(listadj);
        setData1(listadj);
    };

    const onAccZFilterView = () => {
        var listadj = applyFilter(data, "CAP");
        var listadj = cutMovingByAcc(applyFilter(listadj, "ACC_Z"), "ACC_Z", ACC_DEPTH, ACC_DELAY_TIME, -1800);
        setData(listadj);
        setData1(listadj);
    };

    const onAccCutZfilterView = () => {
        var listadj = rmFilter(data, [{ name: 'ACC_Z', beg: -1800, end: -2000 }]);

        var listadj = listadj.map((item: any, index: Number, arr: Array<any>) => {
            return { ...item, CAP: item.CAP_ADJ }
        });
        var listadj = applyFilter(listadj, "CAP");

        setData(listadj);
        setData1(listadj);
    };

    const onAccAllFilterView = () => {
        var listadj = applyFilter(data, "CAP");
        var listadj = cutMovingByAcc(applyFilter(listadj, "ACC_Y"), "ACC_Y", ACC_DEPTH, ACC_DELAY_TIME, -1800);
        var listadj = applyFilter(listadj, "CAP");
        var listadj = cutMovingByAcc(applyFilter(listadj, "ACC_X"), "ACC_X", ACC_DEPTH, ACC_DELAY_TIME, -1800);
        var listadj = applyFilter(listadj, "CAP");
        var listadj = cutMovingByAcc(applyFilter(listadj, "ACC_Z"), "ACC_Z", ACC_DEPTH, ACC_DELAY_TIME, -1800);
        setData(listadj);
        setData1(listadj);
    };

    const CAP_DEPTH = 50;
    const CAP_DELAY_TIME = 0 * 60 * 1000;

    const onCapFilterView = () => {
        var listadj = applyFilter(data, "CAP");
        // var listadj = cutMovingBySTD(listadj, "CAP", 10, 0, 31850)
        var listadj = cutMovingByName(listadj, "CAP", CAP_DEPTH, CAP_DELAY_TIME, 31850)
        setData1(listadj);
    };

    const onCapFilterView2 = () => {
        var listadj = applyFilter(data, "CAP");
        // var listadj = cutMovingBySTD(listadj, "CAP", 15, 0, 31850)
        // var listadj = cutMovingByName(listadj, "CAP", CAP_DEPTH, CAP_DELAY_TIME, 31850)
        var listadj = recMovingByName(listadj, "CAP", CAP_DEPTH, CAP_DELAY_TIME, 31850)
        setData1(listadj);
    };

    const onCapCutFilterView = () => {

        var listadj = rmFilter(data1, [{ name: 'CAP', beg: 31850, end: 31800 }]);

        var listadj = listadj.map((item: any, index: Number, arr: Array<any>) => {
            return { ...item, CAP: item.CAP_ADJ }
        });
        var listadj = applyFilter(listadj, "CAP");
        // var listadj = cutMovingBySTD(listadj, "CAP", 10, 0, 31850)
        var listadj = cutMovingByName(listadj, "CAP", CAP_DEPTH, CAP_DELAY_TIME, 31850);
        setData2(listadj);
    };

    const onCapFinCutFilterView = () => {
        var listadj = rmFilter(data2, [{ name: 'CAP', beg: 31850, end: 31800 }]);
        setData2(listadj);
    };

    const onCapEndFilterView = () => {
        var listadj = data2.map((item: any, index: Number, arr: Array<any>) => {
            return { ...item, CAP: item.CAP_ADJ }
        });
        var listadj = applyFilter(listadj, "CAP");
        setData2(listadj);
    };

    const onCapAllFilterView = () => {
        // var listadj = data.map((item: any, index: Number, arr: Array<any>) => {
        //     return { ...item, CAP: item.CAP_ADJ }
        // });
        var listadj = applyFilter(data, "CAP");
        var listadj = cutMovingByName(listadj, "CAP", CAP_DEPTH, CAP_DELAY_TIME, 31850)
        var listadj = rmFilter(listadj, [{ name: 'CAP', beg: 31850, end: 31800 }]);

        var listadj = listadj.map((item: any, index: Number, arr: Array<any>) => {
            return { ...item, CAP: item.CAP_ADJ }
        });
        var listadj = applyFilter(listadj, "CAP");
        var listadj = cutMovingByName(listadj, "CAP", CAP_DEPTH, CAP_DELAY_TIME, 31850);

        var listadj = rmFilter(listadj, [{ name: 'CAP', beg: 31850, end: 31800 }]);
        var listadj = listadj.map((item: any, index: Number, arr: Array<any>) => {
            return { ...item, CAP: item.CAP_ADJ }
        });
        var listadj = applyFilter(listadj, "CAP");
        // var listadj = cutMovingByName(listadj, "CAP", 30, 1 * 60 * 1000, 31850)
        // var listadj = rmFilter(listadj, [{ name: 'CAP', beg: 31850, end: 31800 }]);
        // var listadj = listadj.map((item: any, index: Number, arr: Array<any>) => {
        //     return { ...item, CAP: item.CAP_ADJ }
        // });
        // var listadj = applyFilter(listadj, "CAP");
        setData1(listadj);
    };

    const onCapAllFilterView2 = () => {
        var listadj = applyFilter(data, "CAP");
        var listadj = recMovingByName(listadj, "CAP", CAP_DEPTH, CAP_DELAY_TIME, 31850)
        var listadj = rmFilter(listadj, [{ name: 'CAP', beg: 31850, end: 31800 }]);

        var listadj = listadj.map((item: any, index: Number, arr: Array<any>) => {
            return { ...item, CAP: item.CAP_ADJ }
        });
        var listadj = applyFilter(listadj, "CAP");
        // var listadj = cutMovingBySTD(listadj, "CAP", 10, 0, 31850)

        var listadj = recMovingByName(listadj, "CAP", 40, CAP_DELAY_TIME, 31850);

        var listadj = rmFilter(listadj, [{ name: 'CAP', beg: 31850, end: 31800 }]);
        var listadj = listadj.map((item: any, index: Number, arr: Array<any>) => {
            return { ...item, CAP: item.CAP_ADJ }
        });
        var listadj = applyFilter(listadj, "CAP");
        setData1(listadj);
    };

    const onMeasurementAsIs = async () => {
        measurement1.device = measurement1.init();
        for (var j = 0; j < data.length; j++) {
            measurement1.device.data['D' + (j % 10)] = data[j];
            if ((j % 10) == 9) {
                measurement1.device.VCC = data[j].VCC;
                measurement1.calcMeasurement(measurement1.device);
            }
        }
    }

    const onMeasurementToBe = async () => {
        var listadj = data1.map((item: any, index: Number, arr: Array<any>) => {
            return { ...item, CAP1: item.CAP_ADJ, time: (new Date(item.TIME)).getTime() }
        });
        measurement2.device = measurement2.init();
        for (var j = 0; j < listadj.length; j++) {
            measurement2.device.data['D' + (j % 10)] = listadj[j];

            if ((j % 10) == 9) {
                measurement2.device.VCC = listadj[j].VCC;
                measurement2.calcMeasurement(measurement2.device);
            }
        }
    }


    const onMeasurementV2 = async () => {

        var listadj = data1.map((item: any, index: Number, arr: Array<any>) => {
            return { ...item, time: (new Date(item.TIME)).getTime() }
        });
        if (listadj.length > 0) {
            console.log('sensorParam=',JSON.stringify(sensorParam));
            measurement2.devlist[0].SENSOR_ID = listadj[0].SENSOR_ID;
            measurement2.diaperchangeUpdate(measurement2.devlist , sensorParam);
            for (var j = 0; j < listadj.length; j++) {
                // listadj[j].time = listadj[j].time + (Date.now() - listadj[j].time);
                measurement2.updateSensorData(listadj[j]);
            }
        }
    }

    const onCheckAuto = async () => {
        console.log('onCheckAuto!!!', autoRefresh);
        intvEabled = !autoRefresh;
        setAutoRefresh(!autoRefresh);
    }

    const [add, setAdd] = useState(false);
    const [addList, setAddList] = useState<any>([]);
    const [addOpen, setAddOpen] = useState(false);
    const [addValue, setAddValue] = useState(null);
    const [pee, setPee] = useState('');
    const [normalcyOpen, setNormalcyOpen] = useState(false);
    const [normalcyList, setNormalcyList] = useState<any>([]);
    const [normalcyValue, setNormalcyValue] = useState(null);
    const [noPeeOpen, setNoPeeOpen] = useState(false);
    const [noPeeList, setNoPeeList] = useState<any>([]);
    const [noPeeValue, setNoPeeValue] = useState(null);

    const onChangePee = (text: any) => {
        setPee(text);
    }

    const onAdd = (num: any) => {
        if (num == 0) {
            if (pee?.length > 0) {
                setAdd(true);
                normalcyList.push({ label: `${sensorID} : ${StartDate} ~ ${EndDate} [${pee}]`, value: { sensorID: sensorID, StartDate: StartDate, EndDate: EndDate, pee: pee } })
                console.log('normalcyList ?? ', normalcyList);
                setStorage('normal', normalcyList);
                setPee('');
            } else {
                alert('소변량을 입력해주세요.')
            }
        } else if (num == 1) {
            setAdd(true);
            noPeeList.push({ label: `${sensorID} : ${StartDate} ~ ${EndDate}`, value: { sensorID: sensorID, StartDate: StartDate, EndDate: EndDate } })
            console.log('normalcyList ?? ', noPeeList);
            setStorage('noPee', noPeeList);
        } else {
            setAdd(true);
            addList.push({ label: `${sensorID} : ${StartDate} ~ ${EndDate}`, value: { sensorID: sensorID, StartDate: StartDate, EndDate: EndDate } })
            console.log('addList ?? ', addList);
            setStorage('addList', addList);
        }
    }

    useEffect(() => {
        const getList = async () => {
            const history = await getStorage('addList');
            const normal = await getStorage('normal');
            const noPee = await getStorage('noPee');
            if (history?.length > 0) {
                setAddList(history);
            }
            if (normal?.length > 0) {
                setNormalcyList(normal);
            }
            if (noPee?.length > 0) {
                setNoPeeList(noPee);
            }
        }
        getList();
        if (add) {
            const getList = async () => {
                const history = await getStorage('addList');
                const normal = await getStorage('normal');
                const noPee = await getStorage('noPee');
                if (history?.length > 0) {
                    setAddList(history);
                }
                if (normal?.length > 0) {
                    setNormalcyList(normal);
                }
                if (noPee?.length > 0) {
                    setNoPeeList(noPee);
                }
            }
            getList();
            setAdd(false)
        }
    }, []);

    useEffect(() => {
        onSearch();
    }, [addValue, normalcyValue, noPeeValue]);

    const onSelectItem = (item: any) => {
        console.log('onSelectItem ?? ', item);
        setSensorID(item?.sensorID);
        setStartDate(new Date(item?.StartDate));
        setEndDate(new Date(item?.EndDate));
        setPee(item?.pee);
    }

    const headers = [
        { label: "TIME", key: "TIME" },
        { label: "ACC_X", key: "ACC_X" },
        { label: "ACC_Y", key: "ACC_Y" },
        { label: "ACC_Z", key: "ACC_Z" },
        { label: "CAP1", key: "CAP1" },
        { label: "CAP2", key: "CAP2" }
    ];

    const onExtract = async () => {
        console.log('onExtract!!!');
        // var listadj = data.map((item: any, index: Number, arr: Array<any>) => {
        //     return { ...item, time: (new Date(item.TIME)).getTime() }
        // });
        var extdata = [];
        var prvtime = (new Date(data[0].TIME)).getTime();
        for (var j = 0; j < data.length; j++) {
            var curtime = (new Date(data[j].TIME)).getTime();

            if ((curtime - prvtime) >= (1000 * 7))  // 8secs
            // if ((j % 10) == 9)  // 10secs
            {
                extdata.push(data[j]);
                prvtime = curtime;
                console.log(data[j]);
            }
        }
        console.log('len=', extdata.length);

        var listadj = extdata.map((item: any, index: Number, arr: Array<any>) => {
            return { ...item, TIME: moment(item.TIME).format('YYYY-MM-DD HH:mm:ss') }
        });
        console.log('listadj ?? ', listadj);
        setData(listadj);
        setData1(listadj);
        setData2(listadj);

        var filename = `CAP[${sensorID}]_${pee}_` + moment(listadj[0].TIME).format('YYYYMMDD_HHmmss');

        setCsvReport({
            data: listadj,
            headers: headers,
            filename: `${filename}.csv`
        });
    };

const getTicksIfLarge = (data, limit = 35) => {
    if (!data || data.length < limit) return undefined;

    return [
        data[0]?.TIME,
        data[data.length - 1]?.TIME
    ];
};
    
const ticks  = getTicksIfLarge(data);
const ticks1 = getTicksIfLarge(data1);
const ticks2 = getTicksIfLarge(data2);
const ticks3 = getTicksIfLarge(data3);
const ticks4 = getTicksIfLarge(data4);

    return (
        <View style={styles.container}>
            <View style={[styles.selectBox, { zIndex: 1000, flexDirection: 'column' }]}>
                <View style={{ zIndex: 1000, flexDirection: 'row', alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap', rowGap: 8 }}>
                    <View style={{ marginHorizontal: 10, alignItems: 'flex-start' }}>
                        <Text style={{ fontSize: 20, color: '#000' }}>{sensorID}</Text>
                        {sensorInfo ? (
                            <Text style={{ fontSize: 14, color: '#555', marginTop: 2 }}>
                                {[sensorInfo.AREA, sensorInfo.NAME].filter(Boolean).join(' · ')}
                            </Text>
                        ) : null}
                    </View>
                    <OnStartDatePicker />
                    <Text style={{ color: '#000', fontSize: 24, marginBottom: 20, marginHorizontal: 10 }}> ~ </Text>
                    <OnEndDatePicker />
                    <TouchableOpacity onPress={() => { onCheckAuto() }}
                        style={{ flexDirection: 'row', alignItems: 'center', marginHorizontal: 10 }} >
                        <CheckBox checked={autoRefresh} />
                        <Text style={{ marginLeft: 5, color: 'green' }}>{'Auto'}</Text>
                    </TouchableOpacity>
                    <TouchableOpacity style={[styles.searchBox, cmpBtn]} onPress={() => { setIsLoading(true); onSearch() }}>
                        <Text style={[styles.searchFont, cmpFont]}>검색</Text>
                    </TouchableOpacity>
                    <TouchableOpacity style={[styles.searchBox, cmpBtn, { backgroundColor: 'green' }]} onPress={() => { onRecentView() }}>
                        <Text style={[styles.searchFont, cmpFont]}>최근보기</Text>
                    </TouchableOpacity>
                    <View style={{ marginLeft: 10 }}>
                        <CSVLink {...sensorValue}>SensorHistory</CSVLink>
                    </View>
                    <View style={{ marginLeft: 10 }}>
                        <CSVLink {...records}>Clinical Records</CSVLink>
                    </View>
                    <View style={{ marginLeft: 10 }}>
                        <CSVLink {...analyze}>AnalyzSensorHis</CSVLink>
                    </View>
                    {/* <TextInput autoCapitalize='none' clearButtonMode='always' placeholder={'소변량을 입력하세요.'}
                        style={styles.textInputBox} onChangeText={(text) => onChangePee(text)} value={pee} />
                    <TouchableOpacity style={[styles.searchBox, cmpBtn, { backgroundColor: 'brown' }]} onPress={() => { onAdd(0) }}>
                        <Text style={[styles.searchFont, cmpFont]}>소변 있음</Text>
                    </TouchableOpacity>
                    <TouchableOpacity style={[styles.searchBox, cmpBtn, { backgroundColor: 'pink' }]} onPress={() => { onAdd(1) }}>
                        <Text style={[styles.searchFont, cmpFont]}>소변 없음</Text>
                    </TouchableOpacity>
                    <TouchableOpacity style={[styles.searchBox, cmpBtn, { backgroundColor: 'orange' }]} onPress={() => { onAdd(2) }}>
                        <Text style={[styles.searchFont, cmpFont]}>히스토리</Text>
                    </TouchableOpacity> */}
                    <TouchableOpacity style={[styles.searchBox, cmpBtn, { backgroundColor: 'red' }]} onPress={() => { onMeasurementAsIs() }}>
                        <Text style={[styles.searchFont, cmpFont]}>Asis</Text>
                    </TouchableOpacity>
                    <TouchableOpacity style={[styles.searchBox, cmpBtn, { backgroundColor: 'red' }]} onPress={() => { onMeasurementToBe() }}>
                        <Text style={[styles.searchFont, cmpFont]}>ToBe</Text>
                    </TouchableOpacity>
                    <TouchableOpacity style={[styles.searchBox, cmpBtn, { backgroundColor: 'red' }]} onPress={() => { onMeasurementV2() }}>
                        <Text style={[styles.searchFont, cmpFont]}>V2</Text>
                    </TouchableOpacity>
                    <TouchableOpacity style={[styles.searchBox, cmpBtn, { backgroundColor: 'green' }]} onPress={() => { onExtract() }}>
                        <Text style={[styles.searchFont, cmpFont]}>{'Extract'}</Text>
                    </TouchableOpacity>
                    {/*<CSVLink {...csvReport}>Download</CSVLink>*/}
                </View>
                {/* <View style={{ zIndex: 10, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                    <TextInput autoCapitalize='none' clearButtonMode='always' placeholder={'소변량을 입력하세요.'}
                        style={styles.textInputBox} onChangeText={(text) => onChangePee(text)} value={pee} />
                    <TouchableOpacity style={[styles.searchBox, cmpBtn, { backgroundColor: 'brown' }]} onPress={() => { onAdd(0) }}>
                        <Text style={[styles.searchFont, cmpFont]}>소변 있음</Text>
                    </TouchableOpacity>
                    <TouchableOpacity style={[styles.searchBox, cmpBtn, { backgroundColor: 'pink' }]} onPress={() => { onAdd(1) }}>
                        <Text style={[styles.searchFont, cmpFont]}>소변 없음</Text>
                    </TouchableOpacity>
                    <TouchableOpacity style={[styles.searchBox, cmpBtn, { backgroundColor: 'orange' }]} onPress={() => { onAdd(2) }}>
                        <Text style={[styles.searchFont, cmpFont]}>히스토리</Text>
                    </TouchableOpacity>
                    <TouchableOpacity style={[styles.searchBox, cmpBtn, { backgroundColor: 'red' }]} onPress={() => { onMeasurementAsIs() }}>
                        <Text style={[styles.searchFont, cmpFont]}>Check As is</Text>
                    </TouchableOpacity>
                    <TouchableOpacity style={[styles.searchBox, cmpBtn, { backgroundColor: 'red' }]} onPress={() => { onMeasurementToBe() }}>
                        <Text style={[styles.searchFont, cmpFont]}>Check To be</Text>
                    </TouchableOpacity>
                </View> */}
                {isNarrowA && (
                    <TouchableOpacity
                        onPress={() => setOptOpen(v => !v)}
                        style={{ alignSelf: 'center', marginTop: 10, paddingVertical: 5, paddingHorizontal: 14,
                                 borderRadius: 14, borderWidth: 1, borderColor: '#cbd5e1', backgroundColor: '#f1f5f9' }}
                    >
                        <Text style={{ fontSize: 12, fontWeight: '700', color: '#475569' }}>
                            {optOpen ? '분석 옵션 접기 ▲' : '분석 옵션 펴기 ▼'}
                        </Text>
                    </TouchableOpacity>
                )}
                <View style={[{ zIndex: 10, flexDirection: 'row', alignItems: 'center', justifyContent: 'center', marginTop: 10, flexWrap: 'wrap', rowGap: 8 },
                              (isNarrowA && !optOpen) ? { display: 'none' } : null]}>
                    <TouchableOpacity style={[styles.searchBox, cmpBtn, { backgroundColor: 'green' }]} onPress={() => { onCap2View() }}>
                        <Text style={[styles.searchFont, cmpFont]}>{'CAP2->1'}</Text>
                    </TouchableOpacity>
                    <TouchableOpacity style={[styles.searchBox, cmpBtn, { backgroundColor: 'green' }]} onPress={() => { onApllyDataView() }}>
                        <Text style={[styles.searchFont, cmpFont]}>Apply</Text>
                    </TouchableOpacity>
                    <TouchableOpacity style={[styles.searchBox, cmpBtn, { backgroundColor: 'green' }]} onPress={() => { onAccYFilterView() }}>
                        <Text style={[styles.searchFont, cmpFont]}>Acc Y </Text>
                    </TouchableOpacity>
                    <TouchableOpacity style={[styles.searchBox, cmpBtn, { backgroundColor: 'green' }]} onPress={() => { onAccXFilterView() }}>
                        <Text style={[styles.searchFont, cmpFont]}>Acc X</Text>
                    </TouchableOpacity>
                    <TouchableOpacity style={[styles.searchBox, cmpBtn, { backgroundColor: 'green' }]} onPress={() => { onAccZFilterView() }}>
                        <Text style={[styles.searchFont, cmpFont]}>Acc Z</Text>
                    </TouchableOpacity>
                    <TouchableOpacity style={[styles.searchBox, cmpBtn, { backgroundColor: 'green' }]} onPress={() => { onAccCutZfilterView() }}>
                        <Text style={[styles.searchFont, cmpFont]}>Cut Z </Text>
                    </TouchableOpacity>
                    <TouchableOpacity style={[styles.searchBox, cmpBtn, { backgroundColor: 'red' }]} onPress={() => { onAccAllFilterView() }}>
                        <Text style={[styles.searchFont, cmpFont]}>Acc All </Text>
                    </TouchableOpacity>
                    <TouchableOpacity style={[styles.searchBox, cmpBtn, { backgroundColor: 'green' }]} onPress={() => { onCapFilterView() }}>
                        <Text style={[styles.searchFont, cmpFont]}>CAP 필터</Text>
                    </TouchableOpacity>
                    <TouchableOpacity style={[styles.searchBox, cmpBtn, { backgroundColor: 'green' }]} onPress={() => { onCapFilterView2() }}>
                        <Text style={[styles.searchFont, cmpFont]}>CAP 필터2</Text>
                    </TouchableOpacity>
                    <TouchableOpacity style={[styles.searchBox, cmpBtn, { backgroundColor: 'green' }]} onPress={() => { onCapCutFilterView() }}>
                        <Text style={[styles.searchFont, cmpFont]}>CAP Cut1 필터</Text>
                    </TouchableOpacity>
                    <TouchableOpacity style={[styles.searchBox, cmpBtn, { backgroundColor: 'green' }]} onPress={() => { onCapFinCutFilterView() }}>
                        <Text style={[styles.searchFont, cmpFont]}>CAP Cut2 필터</Text>
                    </TouchableOpacity>
                    <TouchableOpacity style={[styles.searchBox, cmpBtn, { backgroundColor: 'green' }]} onPress={() => { onCapEndFilterView() }}>
                        <Text style={[styles.searchFont, cmpFont]}>CAP End</Text>
                    </TouchableOpacity>
                    <TouchableOpacity style={[styles.searchBox, cmpBtn, { backgroundColor: 'red' }]} onPress={() => { onCapAllFilterView() }}>
                        <Text style={[styles.searchFont, cmpFont]}>CAP All</Text>
                    </TouchableOpacity>
                    <TouchableOpacity style={[styles.searchBox, cmpBtn, { backgroundColor: 'red' }]} onPress={() => { onCapAllFilterView2() }}>
                        <Text style={[styles.searchFont, cmpFont]}>CAP All2</Text>
                    </TouchableOpacity>
                    {/* <TouchableOpacity style={[styles.searchBox, cmpBtn, { backgroundColor: 'green' }]} onPress={() => { onExtract() }}>
                        <Text style={[styles.searchFont, cmpFont]}>{'Extract'}</Text>
                    </TouchableOpacity>
                    <CSVLink {...csvReport}>Download</CSVLink> */}
                </View>
                {/* <View style={{ zIndex: 10, width: '100%', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-around', marginTop: 10 }}>
                    <View>
                        <Text style={{ marginBottom: 5, marginLeft: 5, fontSize: 15, color: ' #000' }}>소변 있는 데이터</Text>
                        <DropDownPicker
                            style={styles.dropdown}
                            open={normalcyOpen}
                            value={normalcyValue} //addValue
                            items={normalcyList}
                            setOpen={setNormalcyOpen}
                            setValue={setNormalcyValue}
                            setItems={setNormalcyList}
                            placeholder="소변 있는 데이터"
                            placeholderStyle={styles.placeholderStyles}
                            dropDownContainerStyle={{ padding: 10 }}
                            listItemContainerStyle={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}
                            listItemLabelStyle={{ marginTop: 10, fontSize: 14 }}
                            // loading={loading}
                            activityIndicatorColor="#5188E3"
                            searchable={true}
                            searchPlaceholder="Search sensorID"
                            // onOpen={onNormalcyOpen}
                            onSelectItem={(item: any) => { onSelectItem(item?.value) }}
                            zIndex={1000}
                            zIndexInverse={3000}
                        />
                    </View>
                    <View>
                        <Text style={{ marginBottom: 5, marginLeft: 5, fontSize: 15, color: ' #000' }}>소변 없는 데이터</Text>
                        <DropDownPicker
                            style={styles.dropdown}
                            open={noPeeOpen}
                            value={noPeeValue} //addValue
                            items={noPeeList}
                            setOpen={setNoPeeOpen}
                            setValue={setNoPeeValue}
                            setItems={setNoPeeList}
                            placeholder="소변 없는 데이터"
                            placeholderStyle={styles.placeholderStyles}
                            dropDownContainerStyle={{ padding: 10 }}
                            listItemContainerStyle={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}
                            listItemLabelStyle={{ marginTop: 10, fontSize: 14 }}
                            // loading={loading}
                            activityIndicatorColor="#5188E3"
                            searchable={true}
                            searchPlaceholder="Search sensorID"
                            // onOpen={onNoPeeOpen}
                            onSelectItem={(item: any) => { onSelectItem(item?.value) }}
                            zIndex={1000}
                            zIndexInverse={3000}
                        />
                    </View>
                    <View>
                        <Text style={{ marginBottom: 5, marginLeft: 5, fontSize: 15, color: ' #000' }}>히스토리</Text>
                        <DropDownPicker
                            style={styles.dropdown}
                            open={addOpen}
                            value={addValue} //addValue
                            items={addList}
                            setOpen={setAddOpen}
                            setValue={setAddValue}
                            setItems={setAddList}
                            placeholder="히스토리"
                            placeholderStyle={styles.placeholderStyles}
                            dropDownContainerStyle={{ padding: 10 }}
                            listItemContainerStyle={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}
                            listItemLabelStyle={{ marginTop: 10, fontSize: 14 }}
                            // loading={loading}
                            activityIndicatorColor="#5188E3"
                            searchable={true}
                            searchPlaceholder="Search sensorID"
                            // onOpen={onAddOpen}
                            onSelectItem={(item: any) => { onSelectItem(item?.value) }}
                            zIndex={1000}
                            zIndexInverse={3000}
                        />
                    </View>
                </View> */}
            </View>
            <View style={styles.selectBox}>
                {locationItem?.map((item: any) => {
                    return (<CheckList key={item?.dataKey} item={item} num={2} locationItems={locationItems} setLocationItems={setLocationItems} />)
                })}
            </View>

            <View>
                {isLoading ? <ActivityIndicator size="large" color="blue" /> : null}
            </View>
            <View style={{ justifyContent: 'center', alignItems: 'center', width: '100%' }}>
                <LineChart width={chartWidth} height={chartHeight} data={data}
                    margin={{ top: 20, bottom: 20, right: 40 }} >
                    <CartesianGrid strokeDasharray="5 5" />
                    <XAxis
                        dataKey="TIME"
                        type="category"
                        tickFormatter={timeFommet}
                        ticks={ticks}
                        interval={0}
                    />
                    <YAxis domain={['dataMin', 'dataMax']} />
                    {locationItems?.map((item: any) => {
                        return (
                            <Line key={item?.dataKey} type="monotone" dataKey={item?.dataKey} stroke={item?.color} dot={false} />
                        )
                    })}
                    <Line type="monotone" dataKey={'ACC_Y_MOV'} stroke={'red'} dot={false} />
                    <Line type="monotone" dataKey={'ACC_Y_MV5'} stroke={'violet'} dot={false} />
                    <Line type="monotone" dataKey={'ACC_Y_FLT'} stroke={'blue'} dot={false} />
                    <Line type="monotone" dataKey={'ACC_Y_STD'} stroke={'black'} dot={false} />
                    <Line type="monotone" dataKey={'ACC_Y_ADJ'} stroke={'red'} dot={false} />

                    <Line type="monotone" dataKey={'ACC_X_MOV'} stroke={'red'} dot={false} />
                    <Line type="monotone" dataKey={'ACC_X_MV5'} stroke={'violet'} dot={false} />
                    <Line type="monotone" dataKey={'ACC_X_FLT'} stroke={'blue'} dot={false} />
                    <Line type="monotone" dataKey={'ACC_X_STD'} stroke={'black'} dot={false} />
                    <Line type="monotone" dataKey={'ACC_X_ADJ'} stroke={'red'} dot={false} />

                    <Line type="monotone" dataKey={'ACC_Z_MOV'} stroke={'red'} dot={false} />
                    <Line type="monotone" dataKey={'ACC_Z_MV5'} stroke={'violet'} dot={false} />
                    <Line type="monotone" dataKey={'ACC_Z_FLT'} stroke={'blue'} dot={false} />
                    <Line type="monotone" dataKey={'ACC_Z_STD'} stroke={'black'} dot={false} />
                    <Line type="monotone" dataKey={'ACC_Z_ADJ'} stroke={'red'} dot={false} />
                    <Legend />
                    <Tooltip content={CustomTooltip} />
                </LineChart>
            </View>
            <View style={{ justifyContent: 'center', alignItems: 'center', width: '100%' }}>
                {/*
                <LineChart width={chartWidth} height={chartHeight} data={data1}
                    margin={{ top: 20, bottom: 20, right: 40 }} >
                    <CartesianGrid strokeDasharray="5 5" />
                    <XAxis
                        dataKey="TIME"
                        type="category"
                        tickFormatter={timeFommet}
                        ticks={ticks1}
                        interval={0}
                    />
                    <YAxis domain={['dataMin', 'dataMax']} />
                    <Line type="monotone" dataKey={'CAP'} stroke={'green'} dot={false} />
                    <Line type="monotone" dataKey={'CAP_MOV'} stroke={'red'} dot={false} />
                    <Line type="monotone" dataKey={'CAP_MV5'} stroke={'violet'} dot={false} />
                    <Line type="monotone" dataKey={'CAP_FLT'} stroke={'blue'} dot={false} />
                    <Line type="monotone" dataKey={'CAP_FL5'} stroke={'pink'} dot={false} />
                    <Line type="monotone" dataKey={'CAP_STD'} stroke={'black'} dot={false} />
                    <Line type="monotone" dataKey={'CAP_ADJ'} stroke={'orange'} dot={false} />
                    <Legend />
                    <Tooltip content={CustomTooltip} />
                </LineChart>
                */}
                {/*
                <LineChart width={chartWidth} height={chartHeight} data={data2}
                    margin={{ top: 20, bottom: 20, right: 40 }} >
                    <CartesianGrid strokeDasharray="5 5" />
                    <XAxis
                        dataKey="TIME"
                        type="category"
                        tickFormatter={timeFommet}
                        ticks={ticks2}
                        interval={0}
                    />
                    <YAxis domain={['dataMin', 'dataMax']} />
                    <Line type="monotone" dataKey={'CAP2'} stroke={'green'} dot={false} />
                    <Line type="monotone" dataKey={'CAP_MOV'} stroke={'red'} dot={false} />
                    <Line type="monotone" dataKey={'CAP_MV5'} stroke={'violet'} dot={false} />
                    <Line type="monotone" dataKey={'CAP_FLT'} stroke={'blue'} dot={false} />
                    <Line type="monotone" dataKey={'CAP_STD'} stroke={'black'} dot={false} />
                    <Line type="monotone" dataKey={'CAP_ADJ'} stroke={'orange'} dot={false} />
                    <Legend />
                    <Tooltip content={CustomTooltip} />
                </LineChart>
                */}
                {/*
                <LineChart width={chartWidth} height={chartHeight} data={data3}
                    margin={{ top: 20, bottom: 20, right: 40 }} >
                    <CartesianGrid strokeDasharray="5 5" />
                    <XAxis dataKey="TIME" tickFormatter={timeFommet} interval={SizeOfMovingAvg * 2} />
                    <YAxis domain={['dataMin', '15000']} />
                    <Line type="monotone" dataKey={'V1'} stroke={'green'} dot={false} />
                    <Legend />
                    <Tooltip content={CustomTooltip} />
                </LineChart>
                */}
                {/* [2026-10-30] CAP2 를 CAP1 위로 올렸다(요청).
                    위쪽 data1·data2 블록은 주석 처리되어 보이지 않으므로,
                    화면에 실제로 보이는 이 두 그래프의 순서만 바꿨다. */}
                <LineChart width={chartWidth} height={chartHeight} data={data4}
                    margin={{ top: 20, bottom: 20, right: 40 }} >
                    <CartesianGrid strokeDasharray="5 5" />
                    <XAxis
                        dataKey="TIME"
                        type="category"
                        tickFormatter={timeFommet}
                        ticks={ticks4}
                        interval={0}
                    />
                    <YAxis domain={['dataMin', 'dataMax']} />

                    <Line type="monotone" dataKey={'초기화'} stroke={'#6BF082'} dot={{ r: 3, fill: '#6BF082' }} />
                    <Line type="monotone" dataKey={'센서이상'} stroke={'orange'} dot={{ r: 3, fill: 'orange' }} />
                    <Line type="monotone" dataKey={'센서오염'} stroke={'#FFCC00'} dot={{ r: 3, fill: '#FFCC00' }} />
                    <Line type="monotone" dataKey={'기준값'} stroke={'black'} dot={{ r: 3, fill: 'black' }} />
                    <Line type="monotone" dataKey={'소변알림'} stroke={'red'} dot={{ r: 3, fill: 'red' }} />
                    <Line type="monotone" dataKey={"자동교체"} stroke={'violet'} dot={{ r: 3, fill: 'violet' }} />
                    <Line type="monotone" dataKey={'움직임없음'} stroke={'gray'} dot={{ r: 3, fill: 'gray' }} />
                    <Line type="monotone" dataKey={'CAP2'} stroke={'green'} dot={false}  />
                    
                    <Legend />
                    <Tooltip content={CustomTooltip} />
                </LineChart>
                <LineChart width={chartWidth} height={chartHeight} data={data3}
                    margin={{ top: 20, bottom: 20, right: 40 }} >
                    <CartesianGrid strokeDasharray="5 5" />
                    <XAxis
                        dataKey="TIME"
                        type="category"
                        tickFormatter={timeFommet}
                        ticks={ticks3}
                        interval={0}
                    />
                    <YAxis domain={['dataMin', 'dataMax']} />

                    <Line type="monotone" dataKey={'초기화'} stroke={'#6BF082'} dot={{ r: 3, fill: '#6BF082' }} />
                    <Line type="monotone" dataKey={'센서이상'} stroke={"orange"} dot={{ r: 3, fill: 'orange' }} />
                    <Line type="monotone" dataKey={'센서오염'} stroke={'#FFCC00'} dot={{ r: 3, fill: '#FFCC00' }} />
                    <Line type="monotone" dataKey={'기준값'} stroke={'black'} dot={{ r: 3, fill: 'black' }} />
                    <Line type="monotone" dataKey={'소변알림'} stroke={'red'} dot={{ r: 3, fill: 'red' }} />
                    <Line type="monotone" dataKey={"자동교체"} stroke={'violet'} dot={{ r: 3, fill: 'violet' }} />
                    <Line type="monotone" dataKey={'움직임없음'} stroke={'gray'} dot={{ r: 3, fill: 'gray' }} />
                    <Line type="monotone" dataKey={'CAP1'} stroke={'green'} dot={false}  />
        
                    <Legend />
                    <Tooltip content={CustomTooltip} />
                </LineChart>
            </View>
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#fff',
        paddingHorizontal: 30
    },
    selectBox: {
        borderWidth: 1,
        borderRadius: 10,
        width: '100%',
        paddingVertical: 15,
        marginTop: 10,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        borderColor: '#e8eade',
        shadowColor: '#d9dbec',
        shadowOffset: {
            width: 0,
            height: 5,
        },
        shadowOpacity: 0.55,
        shadowRadius: 15,
        elevation: 5,
    },
    tooltip: {
        borderWidth: 1,
        borderColor: '#e8eade',
        padding: 15,
        backgroundColor: '#fff'
    },
    datePickerBox: {
        borderWidth: 1,
        borderColor: 'grey',
        justifyContent: 'center',
        alignItems: 'center',
        width: 180,
        paddingHorizontal: 10,
        paddingVertical: 5,
        borderRadius: 10
    },
    searchBox: {
        backgroundColor: 'skyblue',
        borderRadius: 15,
        alignSelf: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        paddingVertical: 5,
        paddingHorizontal: 15,
        marginLeft: 20
    },
    searchFont: {
        fontSize: 16,
        color: '#fff'
    },
    textInputBox: {
        width: 150,
        height: 40,
        borderWidth: 1,
        borderColor: 'grey',
        borderRadius: 10,
        paddingHorizontal: 13,
        color: '#000',
        marginLeft: 20
    },
    dropdown: {
        borderWidth: 1,
        borderColor: "#B7B7B7",
        borderRadius: 10,
        width: 500,
        height: 40,
        flexDirection: 'row',
        alignItems: 'center',
        padding: 10
    },
    placeholderStyles: {
        color: "#333",
        fontSize: 14,
    },
    sensorValueBox: {
        borderWidth: 1,
        width: 200,
        height: 50,
        borderRadius: 10,
        justifyContent: 'center',
        alignItems: 'center'
    }
});